import ItemView from "./ItemView";

export default class PuzzleItemView extends ItemView {
    
    constructor(target) {
        super(target);
        this._yOrig = this._target.y;
    }

    destroy() {
        super.destroy();
        createjs.Tween.removeTweens(this._target);
        this._target.removeAllEventListeners();
    }

    
    hop() {
        createjs.Tween.get(this._target, { loop: 3 })
            .to({ y: this._yOrig - 50 }, 100, createjs.Ease.linear)
            .to({ y: this._yOrig }, 100, createjs.Ease.linear);
    }

    disappear() {
        const s = 1.2;
        createjs.Tween.get(this._target)
            .to({ y: this._yOrig - 50, scaleX: s, scaleY: s, alpha: 0 }, 300, createjs.Ease.linear);
    }
}